
















import { createComponent } from "@vue/composition-api";

interface Props {}

export default createComponent<Props>({
  components: {},
  props: {},
  setup(props, ctx) {
    const authProfilePictureUrl = gapi.auth2
      .getAuthInstance()
      .currentUser.get()
      .getBasicProfile()
      .getImageUrl();

    const authFullName = gapi.auth2
      .getAuthInstance()
      .currentUser.get()
      .getBasicProfile()
      .getName();

    function logout() {
      return gapi.auth2.getAuthInstance().disconnect();
    }

    return { authProfilePictureUrl, authFullName, logout };
  },
});
